import { Component } from '@builder.io/sdk';

export const config: Component = {
    name: 'Faq SEO',
    inputs: [
        {
            name: 'faqItems',
            type: 'list',
            helperText: 'List of questions and answers',
            required: true,
            defaultValue: [
                {
                    faqQuestion: 'Question',
                    faqAnswer: 'Answer',
                },
            ],
            subFields: [
                {
                    name: 'faqQuestion',
                    type: 'string',
                    required: true,
                    helperText: 'Question',
                    defaultValue: 'Question',
                },
                {
                    name: 'faqAnswer',
                    type: 'richText',
                    required: true,
                    helperText: 'Answer (supports rich text)',
                    defaultValue: 'Answer',
                },
            ],
        },
        {
            name: 'showButton',
            type: 'boolean',
            helperText: 'Show or hide the "See All FAQs" button',
            defaultValue: true,
        },
        {
            name: 'buttonLabel',
            type: 'string',
            helperText: 'Button label',
            defaultValue: 'See All FAQs',
            showIf: `options.get('showButton') === true`,
        },
        {
            name: 'buttonUrl',
            type: 'url',
            helperText: 'Button destination URL (supports additional query parameters)',
            defaultValue: 'https://help.storyblocks.com/en',
            showIf: `options.get('showButton') === true`,
        },
        {
            name: 'titleHeadingLevel',
            type: 'string',
            helperText: 'Heading level of the title; questions use the next level. Match the sections around the FAQ',
            defaultValue: 'h2',
            enum: [
                { label: 'Title H2, questions H3', value: 'h2' },
                { label: 'Title H3, questions H4', value: 'h3' },
            ],
        },
    ],
};
